module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("The Rhetoric of Christian Witness")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last retrait_autre"
  }, [_c('i', [_vm._v("Let your speech always be gracious, seasoned with salt, so that you may know how you ought to answer each person.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLOSSIANS 4:6")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE CONVERTING TO")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIANITY")])]), _vm._v(", Augustine of Hippo had been teaching rhetoric—the study and practice of the art of persuasion—to students in Milan. But upon his conversion, he decided to resign from his prestigious teaching position there. Augustine would leave “the market of speechifying,” he explains in"), _c('i', [_vm._v(" The Confessions,")]), _vm._v(" “so that young boys who were devoting their thoughts . . . to lying follies and legal battles, should no longer buy from [his] mouth the weapons for their frenzy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Augustine had tasted “the real and all-surpassing sweetness” of the Lord, and he no longer wanted to teach students who sought to use rhetoric to make sinfulness seem desirable."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Considered apart from his other writings, Augustine’s account of his conversion and ensuing career change in"), _c('i', [_vm._v(" The Confessions")]), _vm._v(" might seem like a strange way to begin a book that aims, as the present work does, to illustrate and inspire faithful rhetorical activity in the life of the church. But the story does not end there.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Though he gave up his post at Milan, his newfound faith did not curtail his engagement with rhetoric as much as it repurposed it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Augustine’s subsequent writings reveal that he remained a master rhetorician (one who studies the art of persuasion) and a skilled rhetor (one who practices that art); however, his faith allowed him to carry out these activities with their proper end in view."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" From his conversion onward, Augustine sought to use rhetoric to “give conviction to . . . truth” and, ultimately, to help guide people into the joy and rest of the triune God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Augustine’s most thorough reflections on the relationship between Christianity and rhetoric occur in his groundbreaking book"), _c('i', [_vm._v(" On Christian Teaching")]), _vm._v(". Writing to readers who may worry that rhetoric is neither originally nor explicitly Christian, he argues that as long as rhetorical knowledge is in keeping with what Christians believe, we may put it into practice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Otherwise, those people who use rhetoric to “expound falsehoods” will have an advantage over people of faith."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" He asks, “Since rhetoric is used to give conviction to both truth and falsehood, who could dare to maintain that truth, which depends on us for its defence, should stand unarmed in the fight against falsehood?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The implied answer is, of course, nobody. While Augustine does go on to insist that skillful rhetoric (and, more specifically, eloquence) is unnecessary to bring about another’s salvation, he also contends that it can make Christian wisdom more palatable."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" “We "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("often have to take bitter medicines,” he writes, “and we must always avoid sweet things that are dangerous: but what better than sweet things that give health, or medicines that are sweet? The more we are attracted by sweetness, the easier it is for medicine to do its healing work.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Truth presented persuasively is sweet medicine.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For Christian students seeking to learn how to offer this sweet medicine to others—that is, “to speak eloquently as well as wisely”—Augustine points out that the church is full of examples to follow. In fact, there are so many models that “even for students with the leisure to read it is more likely that their time will run out than that these authors will be exhausted.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Faithful rhetoric flourishes in the church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("More than fifteen hundred years later, Augustine’s reflections on rhetoric are as relevant as they have ever been, and contemporary Christians stand to benefit greatly from renewed attention to the subject. This opportunity exists because, despite the church’s frequent attempts at persuasion both inside and outside its walls, Christians do not typically discuss acts of witness in terms of the rhetorical tradition, and such acts are rarely accompanied by rhetorical reflection. Though rhetoric is taught in Christian classical education programs, writing and communication courses at Christian colleges, and some seminary classes, it is seldom mentioned in church settings. In sermons and Sunday school classes, one is much more likely to hear the topic of witness discussed in terms of apologetics. While these discussions may touch on rhetoric, the approaches championed by apologists often represent only a small slice of what the rhetorical tradition has to offer the church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" What is more, Christian publishers have "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("often left the subject of rhetoric to university presses, and on the rare occasion that rhetoric does make an appearance in a book from a Christian press, the subject is usually explored indirectly—again, usually under the guise of apologetics."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To describe this state of affairs using the language of twentieth-century rhetorician Kenneth Burke, members of Christian congregations tend to engage in"), _c('i', [_vm._v(" rhetorica utens")]), _vm._v(" (rhetorical practice) without sufficiently engaging in"), _c('i', [_vm._v(" rhetorica docens")]), _vm._v(" (rhetorical theory)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In light of the wealth of resources that the rhetorical tradition offers speakers and writers who hope to communicate with their audiences more effectively, such uncritical practice almost certainly results in missed opportunities for witness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" It also hampers the church’s ability to critique and reform its own acts of proclamation, increasing the likelihood that Christians will actually alienate the very people they are trying to reach. All too often, in the process of attempting to persuade others of the good news of Jesus Christ, Christians take on rhetorical "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("postures that are inimical to the proclamation of the gospel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" When we do so, we need more than theology to return us to right practice. We also need theologically informed rhetorical reflection"), _c('i', [_vm._v(",")]), _vm._v(" which offers resources both to evaluate our communicative practices and to revise those practices in ways that are consistent with the one who chose the form of the cross as his primary bearing in relation to the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("This book responds to the church’s need for greater rhetorical reflection by inviting readers to consider the rhetorical artistry of five exemplars of Christian witness: C. S. Lewis, Dorothy L. Sayers, Dietrich Bonhoeffer, Desmond Tutu, and Marilynne Robinson. By exploring the rhetoric of these Christians, the book aims to help change perceptions about rhetoric in the church and to demonstrate the importance of rhetorical reflection in a variety of ecclesial and cultural contexts. Though the book’s five central figures are not recognized first and foremost as rhetors or rhetoricians, their work brings into relief a long and immensely fruitful conversation between the rhetorical tradition and the Christian tradition, which begins in Paul’s epistles and continues to the present.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("On Christianity and Rhetoric")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One of the primary reasons for the absence of"), _c('i', [_vm._v(" rhetorica docens")]), _vm._v(" in Christian congregations may be that, outside of academic contexts, the term"), _c('i', [_vm._v(" rhetoric")]), _vm._v(" is almost always used pejoratively."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" The term’s negative connotations have a long history. Plato, who is often presented as one of rhetoric’s earliest detractors, circulated the view that rhetoric was inferior to dialectic (i.e., philosophy), suggesting that the former was concerned only with appearances, while the latter dealt with matters of truth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In Plato’s"), _c('i', [_vm._v(" Gorgias")]), _vm._v(", for example, Socrates famously dismisses rhetoric as a “knack,” which involved acts of “flattery” and was comparable to “pastry baking” and “cosmetics.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" While Socrates speaks more favorably of rhetoric in the"), _c('i', [_vm._v(" Phaedrus")]), _vm._v(" (and even sketches some prerequisites for persuasive "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("practice)"), _c('i', [_vm._v(",")]), _vm._v(" Plato has seldom been described as a champion of the art of persuasion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christian Scripture has been read as dismissive of rhetoric as well, and the apostle Paul’s first letter to the church at Corinth is often invoked in such discussions. In 1 Corinthians 2:1-5, Paul contends that he shared the gospel with the Corinthians without using “lofty speech” or “plausible words of wisdom.” He did so, he tells them, in order that their faith would be built on God’s might and not his own. God’s strength would be the surer foundation. In a remark about these verses that betrays the lingering traces of the association between rhetoric and cosmetics, theologian Kevin Vanhoozer writes, “Paul seems to go out of his way to dissociate himself from orators who employ the rouge of rhetoric in order to make the gospel more attractive.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Vanhoozer’s comment does not indicate that he believes that Paul rejects rhetoric outright, nor does it suggest that he believes that Christians should reject rhetoric; nevertheless, comments such as this subtly reinforce negative views about rhetoric, providing fodder for those who would claim that 1 Corinthians 2:1-5 should be read as a prohibition against all uses of rhetoric. For some, Jesus’s remarks in Matthew 10:17-20 confirm the truth of such a prohibition. After warning his followers that they will be beaten and forced “to bear witness” in the sight of worldly powers and the peoples of the world, Jesus offers the following words of comfort: “When they deliver you over, do not be anxious how you are to speak or what you are to say, for what you are to say will be given to you in that hour. For it is not you who speak, but the Spirit of your Father speaking through you.” When this promise is read alongside Paul’s first letter to the Corinthians, it is easy to see why some Christians may "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("be hesitant to advocate for the study and practice of persuasion in their congregations.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Writing in the sixteenth century, the French humanist Peter Ramus reinforced Plato’s views by distinguishing rhetoric from philosophy and restricting the subject matter of the former. Ancient rhetoricians such as Cicero had taught their students that rhetoric consisted of five canons:"), _c('i', [_vm._v(" invention")]), _vm._v(", the practice of finding ideas, arguments, and means of persuasion;"), _c('i', [_vm._v(" arrangement")]), _vm._v(", the practice of ordering them;"), _c('i', [_vm._v(" style")]), _vm._v(", the practice of expressing them artfully;"), _c('i', [_vm._v(" memory")]), _vm._v(", the practice of storing them in the mind and recollecting them as particular situations warranted; and"), _c('i', [_vm._v(" delivery")]), _vm._v(", their public performance or presentation. Ramus reduced the established canons of rhetoric from five to two, transferring invention, arrangement, and memory to the realm of philosophy. “Dialectic,” Ramus argues in"), _c('i', [_vm._v(" Brutinae Quaestiones")]), _vm._v(", “has three parts—invention of stratagems and arguments, arrangement of these through the syllogism and method, and then memory. . . . Yet what then will be left for rhetoric? Not only style in tropes and figures . . . but also delivery. This alone is the proper virtue of rhetoric.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Ramus’s categories diminished rhetoric greatly. What once had been concerned with habits of mind and the intellect was reduced to matters of eloquence and stylistic embellishment. Ramus’s representations of rhetoric, much like Plato’s, framed rhetoric and truth as opposites, thereby contributing to public skepticism toward discourse described as rhetorical."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Lest it seem that philosophers and theologians are solely responsible for the absence of"), _c('i', [_vm._v(" rhetorica docens")]), _vm._v(" in Christian congregations, it should be noted that some members of the clergy as well as rhetoricians themselves may also be responsible for this state of affairs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-028",
      "id": "ap_ntb-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Pastors and priests influenced by the aforementioned views about rhetoric may be hesitant to talk openly about the subject in their churches for fear that their congregations will come to see them as calculating or, worse, disingenuous and manipulative. And rhetoricians uninformed about Christianity may represent Christians in a way that turns off believers to the discipline: it is not uncommon to read scholarship in rhetorical studies that misrepresents Christians or presents them in an unflattering light."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-029",
      "id": "ap_ntb-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" In light of negative representations of rhetoric by Christians and negative representations of Christians by rhetoricians, it is not surprising that one seldom hears talk about rhetoric within churches today."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-030",
      "id": "ap_ntb-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("And yet, despite negative views about rhetoric"), _c('i', [_vm._v(",")]), _vm._v(" it is also the case that many Christian thinkers"), _c('i', [_vm._v(" have")]), _vm._v(" engaged or embraced the rhetorical tradition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-031",
      "id": "ap_ntb-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" For example, Erasmus of Rotterdam, a Renaissance humanist as well as a Christian priest and theologian, wrote the rhetorical textbook"), _c('i', [_vm._v(" On Copia of Words and Ideas,")]), _vm._v(" which promotes copiousness as a means of improving one’s style and has implications for other rhetorical concepts such as revision and invention. Hugh Blair, George Campbell, and Richard Whately—who, among their various professional roles, were all ministers—championed the use of rhetoric in schools and seminaries during the late eighteenth and early nineteenth centuries."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" And to cite just two contemporary scholars, David Cunningham and André Resner Jr. have recently advanced this conversation by publishing books that respectively explore theology as rhetorical and the intersections among theology, homiletics, and rhetoric.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This list is radically abridged—so much so, in fact, that one might make the claim that it is impossible to truly understand the Western rhetorical tradition apart from Christianity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" And as the brief survey "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("above suggests, Christian scholars and members of the clergy have been particularly active in engaging the tradition. For a whole host of reasons, it is vital that this engagement among scholars and clergy continue and expand; however, I want to suggest here that it is equally important that rhetorical reflection be recovered in, by, and for members of Christian congregations. I believe the people of God stand to benefit greatly from sustained and theologically responsible engagement with the Western rhetorical tradition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One reason for this is that Christians simply cannot avoid practicing rhetoric when witnessing. Rhetoric and truth are not opposites; rather, presentations of the truth are always rhetorical."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Given rhetoric’s inevitability, it behooves Christians to reflect on rhetorical practice and learn how to do it well. Second, since all Christians are called to witness, the domain of rhetoric should not be occupied by seminarians, pastors, and scholars alone. All Christians should have access to the resources that the rhetorical tradition offers. Third, encouraging"), _c('i', [_vm._v(" rhetorica docens")]), _vm._v(" among the laity has the potential to reinvigorate"), _c('i', [_vm._v(" rhetorica utens")]), _vm._v(" in the church and enhance the church’s witness. Members of the laity are too often encouraged to witness using simple formulas, and such approaches frequently fail to meet the demands "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("of context or the specific needs of individuals. The writings of Aristotle, Cicero, Quintilian, Augustine, Erasmus, Blair, Campbell, Whately, Burke, Perelman and Olbrechts-Tyteca, Charland, Cunningham, Resner, and many others offer us resources to do better. By weaving excerpts of the writings of these figures into our Sunday school classes, Christian education classes, book discussions, and sermons, we can expand our repertoire of approaches to Christian witness, address audiences inside and outside of the church more effectively, and perhaps even learn how to participate in worship more fully. Recovering"), _c('i', [_vm._v(" rhetorica docens")]), _vm._v(" in, by, and for the church may help us reinvigorate"), _c('i', [_vm._v(" rhetorica utens.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Recovering rhetorical reflection and reinvigorating our rhetorical practice must begin with Scripture’s views about rhetoric."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" As I have already noted, both Jesus and Paul made remarks that speak to the matter, and interpretations about their comments vary widely. However, in an article exploring 1 Corinthians 2:1-5, Matthew 10:17-20, and other relevant passages of Scripture, communication theorist Kenneth R. Chase observes that there is widespread agreement among Christian scholars that God works through our study and practice of rhetoric."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-038",
      "id": "ap_ntb-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" After reviewing the relevant literature on 1 Corinthians 2:1-5, Chase writes, “Paul’s dissociation of human eloquence and divine power . . . does not establish a clean break between the suasive resources of rhetorical art and the spiritual power of divine wisdom”; instead, Paul’s comments differentiate distinctly Christian rhetoric from non-Christian rhetoric."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-039",
      "id": "ap_ntb-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Chase then goes on to argue against "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("the notion that rhetorical planning and the Spirit’s power are somehow mutually exclusive, making the case that Jesus’s instruction to his followers in Matthew 10:17-20 applies only in the circumstances mentioned by Jesus in the passage—namely, those situations in which a disciple is pressured to witness by those in power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-040",
      "id": "ap_ntb-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Chase’s readings suggest that Scripture allows for the study and practice of the art of persuasion, provided that one is sensitive to the demands of context and maintains a proper perspective about human rhetorical power in relation to both God’s power and earthly powers. Such findings strike me as congruent with the rest of the biblical witness, which affirms and even celebrates the use of language across multiple genres for myriad purposes, including persuasion.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This does not mean, as Augustine suggested, that our witness will necessarily be compromised if we fail to engage in the study and practice of rhetoric. God often acts powerfully in spite of our own actions. What is more, it is ultimately God who underwrites the church’s rhetorical practices and makes them persuasive (or not). It is necessary to admit, therefore, that there may be some limits to what we can say about the persuasiveness of the church’s witness. As Jesus says to Nicodemus in the Gospel of John, “The wind blows where it wishes, and you hear its sound, but you do not know where it comes from or where it goes. So it is with everyone who is born of the Spirit” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Jn+3%3A8&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Jn 3:8")]), _vm._v("). But to admit that God works through our rhetorical practices—and, therefore, that we cannot know everything about how these practices function to persuade—is not to say that the persuasiveness of our witness is completely inscrutable to us. In light of that fact, I seek to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("call the church to engage in a more robust dialogue with the rhetorical tradition in hopes that such dialogue will help us better understand, and enhance the effectiveness of, our witness.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One of the tradition’s—and this book’s—key rhetorical concepts is"), _c('i', [_vm._v(" ēthos.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-041",
      "id": "ap_ntb-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" According to Aristotle"), _c('i', [_vm._v(", ēthos")]), _vm._v(" is one of three rhetorical appeals by which a rhetor persuades an audience."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-042",
      "id": "ap_ntb-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('i', [_vm._v("Ēthos")]), _vm._v(", the appeal to one’s character or credibility, accounts for the fact that a rhetor’s ability to persuade an audience is tied to who the rhetor is or who he or she appears to be. Arguments from"), _c('i', [_vm._v(" ēthos")]), _vm._v(" can take many different forms, and we can get a sense of this variety by considering the apostle Paul’s rhetoric, which presents us with an argument from"), _c('i', [_vm._v(" ēthos")]), _vm._v(" that flips the notion on its head. As André Resner Jr. has noted, the apostle Paul constructs a “reverse-"), _c('i', [_vm._v("ēthos")]), _vm._v(" argument” in his first letter to the church at Corinth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-043",
      "id": "ap_ntb-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Recognizing that one’s weaknesses are actually strengths "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("when understood in light of the logic of the cross of Christ, Paul embraces the accusations of his detractors. He uses the critiques meant to undermine his rhetorical authority in order to justify that authority. Resner’s observations remind us that, because Christians cling to the wisdom of the cross, our exploration of the rhetoric of Christian witness may reveal communicative postures and strategies that are at odds with what previous rhetoricians have taught us about persuasion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-044",
      "id": "ap_ntb-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" This is not to say, however, that all of the rhetorical moves described in the proceeding pages will look identical to Paul’s “reverse-"), _c('i', [_vm._v("ēthos")]), _vm._v(" argument.” This book presents readers with a variety of ways that Christians have established"), _c('i', [_vm._v(" ēthos")]), _vm._v(" when witnessing"), _c('i', [_vm._v(",")]), _vm._v(" both individually and collectively."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-045",
      "id": "ap_ntb-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" That said, in these pages I have tried to focus on rhetorics that all find their power in the gospel of Jesus Christ.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Rhetorics of Worship")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Over the course of the book, I draw on the work of theologians such as Simon Chan, Stanley Hauerwas, Jennifer M. McBride, and John Webster to make the case that some of the most persuasive forms of Christian witness are constructed by the worshiping body of Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-046",
      "id": "ap_ntb-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("This argument extends recent work about the relationship between liturgy and Christian formation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-047",
      "id": "ap_ntb-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In"), _c('i', [_vm._v(" Desiring the Kingdom: Worship, Worldview, and Cultural Formation,")]), _vm._v(" philosopher James K. A. Smith suggests that the liturgies we participate in, whether they are Christian or not, order our loves and influence who we are, how we think and feel, and what we do in the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-048",
      "id": "ap_ntb-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Smith goes on to demonstrate, in this book and subsequent ones, just how crucial Christian worship practices are, both for our spiritual formation and also for our educational, missional, and political endeavors. Jennifer M. McBride makes a related point in"), _c('i', [_vm._v(" Radical Discipleship: A Liturgical Politics of the Gospel")]), _vm._v("—a book that grew out of McBride’s involvement with a justice-seeking Christian community in Atlanta, Georgia."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-049",
      "id": "ap_ntb-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" McBride’s work in the community coincided with the seasons of the Christian year, which, she claims, brought the value of observing “a deeply liturgical life” home to her."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-050",
      "id": "ap_ntb-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" To emphasize this point, McBride organizes the chapters of her book according to the seasons of the Christian year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-051",
      "id": "ap_ntb-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Her account of her journey from Advent through Pentecost with the Atlanta-based community instructively highlights that, for those seeking to follow the gospel of Jesus Christ, one’s own formation is indeed a matter of great import. But McBride’s account also highlights that individual formation alone is insufficient: one’s “personal transformation” also ought to be connected to “social and personal transformation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-052",
      "id": "ap_ntb-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Thus, her "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("book’s procession through the Christian year highlights the “social and political significance of [each] liturgical season.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-053",
      "id": "ap_ntb-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Smith’s trilogy and McBride’s"), _c('i', [_vm._v(" Radical Discipleship")]), _vm._v(" do an excellent job of explaining how liturgies relate to Christian formation as well as “social and political” transformation; however, more work is needed that considers the implications of Smith’s and McBride’s arguments about liturgy for the rhetoric of Christian witness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-054",
      "id": "ap_ntb-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" That is, we need to consider not only how worship forms our identities and transforms social and political realities but also how worship forms Christians into people fit to respond to the communicative challenges of the Great Commission. Put another way, we need to extend existing conversations about the ways that Christian liturgies shape the character of individuals and society by considering how our liturgies relate to various constructions of rhetorical character, or"), _c('i', [_vm._v(" ēthos.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-055",
      "id": "ap_ntb-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("This study comprises five interconnected case studies and a concluding chapter that attempts to weave the preceding chapters together. Each case study explores the rhetoric of an influential Christian writer, focusing on his or her appeals to"), _c('i', [_vm._v(" ēthos")]), _vm._v(" or another closely related concept"), _c('i', [_vm._v(".")]), _vm._v(" This material is arranged so as to present information from the history of rhetoric more or less chronologically. But the book’s more fundamental structure proceeds according to the church’s clock. Taking a cue from McBride, my chapters track with the times and seasons of the church year: Advent, Christmas, Epiphany, Lent, Easter, and Pentecost. And the book also keeps time on a smaller scale. As my titles and epigraphs suggest, each chapter is themed around a different element of the Christian worship service: collect, creed, sermon, confession, Eucharist, and benediction."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-056",
      "id": "ap_ntb-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" This arrangement stems from my conviction that such ways of ordering time are among the church’s, and indeed all of humanity’s, greatest rhetorical achievements.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The church year is, as Phillip Pfatteicher rightly notes, a “collective composition, shaped over many centuries, even millennia, by diverse hands and many cultures.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-057",
      "id": "ap_ntb-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The same is true of patterns of Christian "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("worship. And these collective compositions—the church year and patterns of Christian worship—can be persuasive: they can function, to cite Augustine’s adaptation of Cicero’s formula, “to instruct, delight, and move” us."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-058",
      "id": "ap_ntb-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" What is more, as Smith and others have shown, the forms and practices associated with the church year and Christian worship can “constitute our character,” both individually and collectively."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-059",
      "id": "ap_ntb-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Rhetoricians refer to discourse that functions this way using the term"), _c('i', [_vm._v(" constitutive rhetoric")]), _vm._v(" (a notion we will return to later in the book). Through their persuasive and constitutive functions, rhetorics of the church year and Christian worship orient us in particular ways toward God and one another. But even more significant for my purposes, these rhetorics orient us in particular ways toward the world, shaping the rhetoric of our witness. In other words, the rhetorics of the church year and Christian worship are not just for those inside the church but for the whole of humanity. This book, then, invites Christians to pay greater attention to the relationship between our rhetorics of worship and witness. Attending to the ways that we worship God throughout the seasons of the church year may help us respond to Paul’s exhortation to season our speech ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Col+4%3A6&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Col 4:6")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-060",
      "id": "ap_ntb-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My use of Paul’s metaphor of seasoned speech should not be taken to mean that I think rhetoric’s scope ought to be limited to matters of presentation (as Plato, Ramus, and even Augustine suggested). Practicing rhetoric is not simply about flavoring the truth with a dash of eloquence; it involves the discovery, invention, analysis, interpretation, construction, recollection, arrangement,"), _c('i', [_vm._v(" and")]), _vm._v(" presentation of information, knowledge, and wisdom. And rhetorical activity is also not "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("merely about appearances. It can be profoundly true. Consider, for example, Pfatteicher’s following comments about the church year, keeping in mind my remark that this way of ordering time is indeed rhetorical:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The liturgical year is not a mere commemoration of the events of the Gospel; it is in fact the actualization of these events, their renewal upon earth. Thus the act of salvation—begun in Bethlehem, accomplished on Good Friday, vindicated on Easter Day, crowned on Ascension Day—is an ever-continuing process as its fruits are made real in the lives of those who accept this redemption. The Church’s calendar, its day-by-day observance of the liturgical year, is not only a pious recollection of historic events and people. The liturgical year is not a lifeless representation of the events of the past or a bare record of a former age. It is rather Christ himself who is ever living in his Church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-061",
      "id": "ap_ntb-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Therefore, though stylistic elements are included in my conception of “seasoned speech,” they are far from the whole. I also use the phrase to refer to speech that resonates with the seasons of the church year as well as speech that stems from our liturgical-rhetorical traditions and, thus, has been “fitted for use” or “matured.” To be clear, I am not using the phrase to suggest that speech that resonates with a particular season of the church year must only be used during that season; rather, I want to maintain that we ought to study seasonally relevant speech so that, to borrow again from Paul, we will “be ready in season and out of season” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Tim+4%3A2&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("2 Tim 4:2")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Overview")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("Chapter one")]), _vm._v(" explores how C. S. Lewis establishes goodwill in his writings through an analysis of his essays in"), _c('i', [_vm._v(" God in the Dock")]), _vm._v(". The "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre3#pre-002"
    }
  }, [_vm._v("chapter introduces")]), _vm._v(" readers to Aristotle’s explanation of the ways that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("rhetors can establish the argument from"), _c('i', [_vm._v(" ēthos")]), _vm._v(". "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter two")]), _vm._v(" analyzes Dorothy L. Sayers’s radio play"), _c('i', [_vm._v(" He That Should Come")]), _vm._v(" and several of her other writings to make the case that Sayers utilizes what Quintilian refers to as"), _c('i', [_vm._v(" enargeia")]), _vm._v(" to confront her audience with the audacity of the creeds. Chapter three explores Dietrich Bonhoeffer’s work in light of Kenneth Burke’s descriptions of identification and division. I focus on Bonhoeffer’s attempts to align himself with or distance himself from various audiences and the resultant clarity or obscurity of his witness with respect to these audiences. Chapter four brings Desmond Tutu’s appeals as chair of the South African Truth and Reconciliation Commission into conversation with journalist Antjie Krog’s account of the TRC. In this chapter, I suggest that Krog’s book"), _c('i', [_vm._v(" Country of My Skull")]), _vm._v(" serves as an act of repentance in response to Tutu’s constitutive rhetoric of"), _c('i', [_vm._v(" ubuntu")]), _vm._v(". Chapter five offers a reading of Marilynne Robinson’s Gilead trilogy in light of premodern understandings of"), _c('i', [_vm._v(" ēthos.")]), _vm._v(" To borrow two phrases from rhetorician Michael J. Hyde’s discussion of"), _c('i', [_vm._v(" ēthos,")]), _vm._v(" my analysis suggests that Robinson’s narrative rhetoric “grants . . ."), _c('i', [_vm._v(" living room")]), _vm._v(" to” the Christian faith, helping her readers to “feel more"), _c('i', [_vm._v(" at home")]), _vm._v("” with belief and some of its most difficult questions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-062",
      "id": "ap_ntb-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The arc of the book’s argument is to move from a discussion of individual postures of Christian witness ("), _c('i', [_vm._v("ēthos")]), _vm._v(" as an appeal to an individual’s character) to a discussion of communal ones ("), _c('i', [_vm._v("ēthos")]), _vm._v(" as an appealing gathering place). In light of this trajectory, the final chapter breaks from the conventions of previous chapters. Instead of looking at the rhetorical postures of an influential individual, I bring back all of the book’s figures and introduce readers to Mikhail Bakhtin’s concept of heteroglossia in order to reflect on the polyvocality of Christian witness.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("Taken together, the chapters demonstrate that Christians can enhance the persuasiveness of our witness as individuals and create a hospitable community for wanderers and wayfarers by paying careful attention to both the rhetorical tradition and our own liturgical practices. In brief, I want to encourage church members to reflect on various aspects of the rhetorical tradition, highlight important and practical ways of establishing"), _c('i', [_vm._v(" ēthos")]), _vm._v(" when witnessing, and bring the rhetorical facets of Christian worship into relief.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is my hope that the rhetorics of Christian witness explored in this book will provide fodder for reflection, discussion, and perhaps even imitation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-063",
      "id": "ap_ntb-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" In both the Western rhetorical tradition and the Christian tradition, imitation has long been viewed as a highly worthwhile practice. Ancient rhetoricians taught their students the art of rhetoric by having them imitate model texts, and many contemporary speech and writing teachers (myself included) still ask the same of their students."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-064",
      "id": "ap_ntb-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Correspondingly, the apostle Paul encouraged the people at Corinth to model their lives on him even as he modeled his own life on the Lord Jesus, writing, “Be imitators of me, as I am of Christ” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Cor+11%3A1&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Cor 11:1")]), _vm._v("). And Thomas à Kempis began the "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("first chapter")]), _vm._v(" of his great devotional work,"), _c('i', [_vm._v(" The Imitation of Christ,")]), _vm._v(" by suggesting that followers of Jesus Christ ought to “imitate His life and His ways, if we truly desire to be enlightened and free of all blindness of heart.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-065",
      "id": "ap_ntb-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Practicing imitation as a rhetor, a disciple of Jesus Christ, or both does"), _c('i', [_vm._v(" not")]), _vm._v(" mean that we simply copy what has come before us. As rhetorician Michael Leff noted, practicing imitation was not understood by ancient rhetoricians to involve “mere repetition or mechanistic reproduction of something found in an existing text.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-066",
      "id": "ap_ntb-066-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Rather, it was seen as an instrument of invention, of making something new by way of remaking something old."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-067",
      "id": "ap_ntb-067-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Such invention was partially a product of the rhetor’s unique rhetorical situation. Existing forms had to be transformed to meet the distinctive demands of the present context."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-068",
      "id": "ap_ntb-068-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Invention also resulted from other creative activities involved in the practice of imitation, including, Leff suggested, the recovery, interpretation, application, and re-embodiment of prior language use."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-069",
      "id": "ap_ntb-069-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" The major figures discussed here all practice rhetoric in this more dynamic sense, remaking past practices in present contexts to witness to the gospel of Jesus Christ. Their words are grounded firmly in the truth, but they have been seasoned with the salt of the saints who went before them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("May this study of their speech season your own.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0